import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gofore': {
    width: 400,
    height: 512,
    paths: [
      {
        d: 'M324 319.8c54.3 0 65.7 50.1 67.7 77.7-46.5 56.3-107.8 82.5-171 82.5-123.7 0-220.7-101.5-220.7-224 0-123.4 98-224 220.7-224 59 0 114.3 23.3 156.1 65.6l-62.3 63.3c-25-25.4-58.3-39.4-93.6-39.4-73.2 0-132.4 60.3-132.4 134.4 0 74.2 59.2 134.4 132.4 134.4 33.6 0 65.4-12.7 89.9-35.8v-34.7h13.2zM311.9 207.3c47.7 0 88.1 35 88.1 100.2v30.6c-15.5-26.7-42.5-41.8-76-41.8h-118.4v-89h106.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gofore.js
// module id = 862
// module chunks = 0